import { SubjectsQuery } from '@school_ify/schoolify-repository/src/shared/types';
import { TeacherClassSubjectFragment } from '@school_ify/schoolify-repository/src/teacher/types';

import { IAction } from 'redux/actions';

import { StudyTypes } from './types';

const { ADD_ACTIVE_CLASS, ADD_CLASSES } = StudyTypes;

export const addClasses = (
  payload: SubjectsQuery | TeacherClassSubjectFragment
): IAction<typeof ADD_CLASSES, SubjectsQuery | TeacherClassSubjectFragment> => ({
  type: ADD_CLASSES,
  payload,
});

export const addActiveClass = (
  payload: SubjectsQuery
): IAction<typeof ADD_ACTIVE_CLASS, SubjectsQuery> => ({
  type: ADD_ACTIVE_CLASS,
  payload,
});
